module.exports = __webpack_public_path__ + "static/media/test.00172c6e.png";